import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';

export default function About() {
  const navigate = useNavigate();

  return (
    <Row>
      <div>
        <Breadcrumb>
          <BreadcrumbItem onClick={() => navigate(-1)}>Atrás</BreadcrumbItem>
          <BreadcrumbItem active>Sobre mí</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <Col xs="12" md="6" lg="4">
        <img
          src="https://diestrocorp.com.ar/mine/diestrocorp/portfolio-matias-perez-dev/img/profile.jpg"
          className="img-responsive rounded-sm"
        />
      </Col>
      <Col xs="12" md="6" lg="8">
        <br />
        <h2>Sobre mí</h2>
        <p>
          Aloha! Soy Matías Pérez, alias Diestro. Originario de Buenos Aires,
          Argentina, hace unos años descubrí la programación y desde entonces me
          he dedicado a formarme en desarrollo web, por medio de varios cursos y
          prácticas autodidactas.
          <br />
          Decidí crear este blog para poner en práctica mis conocimientos de
          varias tecnologías, y compartir aquellos tips que me han servido en
          este camino, además de tener una base de información a la cual
          recurrir cuando necesite un ayudamemoria, como suele decirse.
          <br />
          Espero este blog sea tan útil para quien se tope con él, como para mí
          fueron estas enseñanzas cuando me fueron brindadas.
          <br />
          Hagamos de seguir aprendiendo una parte de nuestras vidas, en este
          bello camino que es el mundo del código :)
        </p>
      </Col>
    </Row>
  );
}
